import React from "react";
import { connect } from "react-redux";
import Background from "./hoc/Layout/Background/Background";
import Header from "./hoc/Layout/Header/Header";
import Main from "./hoc/Layout/Main/Main";

import Section from "./containers/Section/Section";
import Panels from "./containers/Panels/Panels";
import Report from "./containers/Report/Report";

import AddMetaTag1 from "./components/AddMetaTag1/AddMetaTag1";
import Nav2 from "./components/Navigation/Nav2/Nav2";
import Footer from "./components/Footer/Footer";
import Gate from "./components/Gate/Gate";
import Gate1 from "./components/Gate/Gate1";
import Saleschat from "./components/Saleschat/Saleschat";
import SpiderClass from "./components/Spider/SpiderClass";
import { custState } from "./customHooks/customHooks";
import * as actionCreators from "./store/actions/index";

import QuestionSets from "./libs/QuestionSets";
import "./App.scss";

const App = (props) => {
  const search = window.location.search; // could be '?foo=bar'
  const params = new URLSearchParams(search);
  const skip = params.get("skip");
  const report = params.get("report");
  const role = params.get("role") && params.get("role").split("_").join(" ");
  let score = params.get("score");
  score = score ? score.split("_").map((scr) => Number(scr)) : null;

  //sets cust state to skip if skip
  setCustSkipAndRole(skip, props, role);

  const retThis = report ? (
    <React.Fragment>
      {/*showGate*/}
      <Gate1 />
      <Report scrs={score} rol={role} />
    </React.Fragment>
  ) : (
    <React.Fragment>
      <AddMetaTag1 />
      <Gate1 />
      <Header />
      <Main>
        <Section side={"left"}>
          <Panels skipped={skip} panels={QuestionSets} />
        </Section>
        <Section side={"right"}>
          <SpiderClass />
        </Section>
      </Main>
      <Background />
      <Nav2 />
      <Footer />
      <Saleschat />
      {/* {renderFormsRepost(props.currentQuestion, props.currentQuestions.length, props.currentScores)} */}
    </React.Fragment>
  );

  return retThis;
};

export default connect(mapStateToProps, mapDispatchToProps)(App);

function mapStateToProps(state) {
  return {
    currentQuestions: state.questionsReducer.currentQuestions,
    currentQuestion: state.questionsReducer.currentQuestion,
    currentScores: state.scoreReducer.specificScore,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeRole: (role, lang) =>
      dispatch(actionCreators.choose_role(role, lang)),
    onChooseQuestions: (role, lang) =>
      dispatch(actionCreators.choose_questions(role, lang)),
    onResetScores: (r) => dispatch(actionCreators.reset_scores(r)),
    onUpdatePeerScores: (r) => dispatch(actionCreators.update_peerscore(r)),
  };
}

function setCustSkipAndRole(skip, props, role) {
  if (skip) {
    custState.skip = skip;
    props.onChangeRole(role);
    props.onChooseQuestions(role, "English");
    props.onResetScores(role);
    props.onUpdatePeerScores(role);
  }
}
